import React, { useEffect, useState } from 'react';
import { SystemLogsOUSRegions } from '../../helpers/constants';
import { systemLogFilterMessages, downloadFileMessages } from '../../helpers/messages';
import ErrorMsgBlockComponent from "../Error/ErrorMessageBlock";
import environment from '../../config/environment';

const Download = (props) => {
	const [isOUS, setIsOUS] = useState(false);
	const [confirmChecked, setConfirmChecked] = useState(false);
	const [phiValue, setPhiValue] = useState('no');
	const [ousError, setOUSError] = useState('');

	useEffect(() => {
		if (props.searchParams?.region) {
			setIsOUS(SystemLogsOUSRegions.indexOf(props.searchParams?.region) > -1)
		}
	}, [props])

	const handleDownload = () => {
		let errorFlag = isOUS && !confirmChecked;
		setOUSError(errorFlag ? systemLogFilterMessages.errorOUS : '');
		if (errorFlag) {
			return;
		} else {
			props.handleDownload({
				...props.downloadFileObj,
				phivalue: phiValue === 'yes'
			})
		}
	}

	return (<>


		{isOUS ? <>
			<div className="row">
				<div className="col-sm-12">
					<p className="h6 mb-3">Do you wish to continue without including limited PHI data in your download?</p>

					<label className="chk-label d-inline">
						<input disabled={props.isFilePreparing || props.downloadSuccess} type="checkbox" id="disclaimerchk" data-testid="disclaimerchk" className="chk-input" checked={confirmChecked} onChange={(e) => setConfirmChecked(e.target.checked)} />
						&nbsp;<span className="red">*</span>&nbsp;I confirm that this download does not contain personal data and that I have employed the steps outlined in our procedure to exclude all personal data
						(see HIPAA guidelines provided by S+N <a target="_blank" rel="noreferrer" href={environment.noPhiHIPAAPolicyURL} className="btn-link">here</a>).
					</label>
					{ousError && <div className="customer-error-msg">
						<p>{ousError}</p>
					</div>}
				</div>
			</div>
		</> : <>
			<div className="row">
				<div className="col-sm-12">
					<p className="h6 mb-3">Do you wish to include limited PHI data in your download?</p>

					<div className="phi-consent-wrap d-flex flex-column align-items-top">
						<div className="form-check">
							<input disabled={props.isFilePreparing || props.downloadSuccess} className="form-check-input" type="radio" name="phiConsent" id="phiConsentNo" value="no" checked={phiValue === 'no'} onChange={(e) => setPhiValue(e.target.value)} />
							<label className="form-check-label" htmlFor="phiConsentNo">No, I do not want to download any PHI data</label>
						</div>

						<div className="form-check mt-2">
							<input disabled={props.isFilePreparing || props.downloadSuccess} className="form-check-input" type="radio" name="phiConsent" id="phiConsentYes" value="yes" checked={phiValue === 'yes'} onChange={(e) => setPhiValue(e.target.value)} />
							<label className="form-check-label" htmlFor="phiConsentYes">
								Yes, I acknowledge there is a critical need to download and access PHI data and understand my responsibilities under applicable privacy and data protection laws.
								I confirm that I will handle the PHI in accordance with organizational policies (see HIPAA guidelines provided by S+N <a target="_blank" rel="noreferrer" href={environment.phiHIPAAPolicyURL}>here</a>).
							</label>
						</div>
					</div>
				</div>
			</div>
		</>}
		{props.isFilePreparing && (
			<div className="text-success mb-1 text-aign-center">
				<span>{downloadFileMessages.isFilePreparing}</span>
			</div>
		)}
		{props.downloadSuccess && (
			<div className="text-success mb-1 text-aign-center">
				<span>{downloadFileMessages.success}</span>
			</div>
		)}
		{props.downloadError && (
			<ErrorMsgBlockComponent errorObject={props.downloadError} />
		)}
		<hr />
		<div className="row">
			<div className="col-sm-12 text-end">
				{
					(!props.isFilePreparing && !props.downloadSuccess) ? <>
						<button type="button" id="continue-btn" className="btn btn-primary" onClick={handleDownload}>Download</button>
						<button type="button" id="cancel-btn" className="btn btn-secondary ms-2" onClick={props.handleDownloadCancel}>Cancel</button>
					</> :
						<button type="button" className="btn btn-secondary ms-2" id="cancel" onClick={props.handleDownloadCancel}>Close</button>
				}

			</div>
		</div>
	</>);
}

export default Download;
